@let transaction = transaction$ | async;

@if (!transaction) {
  <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL()" />

  <app-details-page-content-placeholder [singleColumn]="true" />
} @else {
  <app-details-page-header
    [pageReturnURL]="pageReturnURL()"
    [title]="transaction.id"
    [status]="transaction.latestStatus.status"
    [breadcrumbs]="breadcrumbs()"
  />

  <ul class="tab-nav-items mt-4">
    @for (tab of tabItems(); track $index) {
      <li class="tab-nav-item">
        @if (isActive(tab.href)) {
          <a class="tab-nav-link active">{{ tab.tabName }}</a>
        } @else {
          <a [routerLink]="tab.href" class="tab-nav-link">{{ tab.tabName }}</a>
        }
      </li>
    }
  </ul>

  <router-outlet />
}
